module.exports = __webpack_public_path__ + "img/banner-swiper1-hen.f4d7b87e.png";